// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1__d74d537c56ecdb8a37be","cls2":"Base-cls2__d22b5d4cfd49254dcd29 Base-cls1__d74d537c56ecdb8a37be"};